import React from 'react';
import { useWeb3 } from '../contexts/Web3Context';

const WalletConnect: React.FC = () => {
  const { account, isConnected, connectWallet, disconnectWallet } = useWeb3();

  const formatAddress = (address: string) => {
    return address ? `${address.slice(0, 6)}...${address.slice(-4)}` : '';
  };

  if (!isConnected) {
    return (
      <button className="wallet-btn" onClick={connectWallet}>
        Connect Wallet
      </button>
    );
  }

  return (
    <div className="wallet-connected">
      <div className="wallet-status"></div>
      <div className="wallet-address">{formatAddress(account!)}</div>
      <button className="disconnect-btn" onClick={disconnectWallet}>
        Disconnect
      </button>
    </div>
  );
};

export default WalletConnect;
